import { FC, ReactNode, ReactElement } from "react";
import classnames from 'classnames';
import { LayOutPageLeftsProps, LayOutPageLeftItemProps, LayOutPageItemEnum, ILayOutPageLeftsInfo, } from "../interface";

const LayOutPageLefts: FC<LayOutPageLeftsProps> = props => {
  const { children, className, ...restProps } = props;
  const classes = classnames('yb-layout-page-lefts', className);
  const renderChildren = (childrenNodes: ReactNode): ReactElement => {
    const contentInfo: ILayOutPageLeftsInfo = {
      item: [],
      page: [],
    };
    if (Array.isArray(childrenNodes) && childrenNodes.length) {
      childrenNodes.forEach(item => {
        const childElement = item as React.FunctionComponentElement<LayOutPageLeftItemProps>;
        if (!childElement.type) return null;
        const { displayName } = childElement.type;
        switch (displayName) {
          case LayOutPageItemEnum.LeftItem:
            contentInfo.item.push(item);
            break;
          case LayOutPageItemEnum.LeftPage:
            contentInfo.page.push(item);
            break;
          default:
            return;
        }
      });
    } else {
      if (childrenNodes) return renderChildren([childrenNodes]);
    }
    return (
      <>
        <div className={classes} {...restProps}>
          {contentInfo.item}
          {contentInfo.page}
        </div>
      </>
    );
  };
  return renderChildren(children);
};

LayOutPageLefts.displayName = LayOutPageItemEnum.Lefts;

export default LayOutPageLefts;
